module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_f_leucistic.bd5b1d8a.png";